export type AreaId = string;

// используется для аналитики
export enum AreaEnum {
    MSK = 'MSK',
    SPB = 'SPB',
    ALL = 'ALL',
    LOCAL = 'LOCAL',
}

export interface AreaTreeDto {
    id: AreaId;
    areas: AreaTreeDto[];
    parentId: string;
    name: string;
}

export interface AreaLeavesDto {
    id: AreaId;
    text: string;
}
